import { Box, Modal, ModalBody, ModalContent, ModalHeader, ModalOverlay } from "@chakra-ui/react";
import React from "react";
import APButton from "../APButton";
import { FloSplashInlined } from "../APAssetAtlas";
import { useVocabIntl } from "../../hooks/useVocabTranslation";

interface LoginPrompt {
  isOpen: boolean,
  onSignIn: () => void,
  onSignUp: () => void,
  onContinue: () => void
}

export function LoginPromptModal({ isOpen, onSignIn, onSignUp, onContinue }: LoginPrompt) {
  const {APFormattedMessage}=useVocabIntl()
  return (
    <Modal
      closeOnOverlayClick={false}
      isOpen={isOpen}
      onClose={onContinue}
      variant={"splashModal"}
      size="sm">
      <ModalOverlay>
        <ModalContent>
          <ModalHeader bgColor={"lightBlue.500"} display={"flex"} borderTopRadius={"1.5rem"} gap={["0.5rem", "1rem"]}
                       alignItems={"center"} maxHeight={"60%"} minHeight={"60%"} flexDirection={"column"}>
            <Box textAlign={"center"} fontSize={["2xl", "3xl"]} fontWeight={"bold"}>
              <APFormattedMessage id={"login-heading"} />
            </Box>
            <Box textAlign={"center"} fontSize={["lg", "xl"]} lineHeight={"1.3"} fontWeight={"normal"}>
              <APFormattedMessage id={"login-subheading"} />
            </Box>

            <FloSplashInlined height={"100%"} minHeight={"4rem"} maxHeight={"256px"} />
          </ModalHeader>
          <ModalBody display={"flex"} alignItems={"stretch"} flexDir={"column"} gap={"1rem"} maxHeight={"40%"}>

            <APButton flexFill
                      onClick={() => onSignIn()}>
              <APFormattedMessage id={"login"}  />
            </APButton>

            <APButton flexFill variant={"solid"} colorScheme={"tertiary"}
                      onClick={() => onSignUp()}>
              <APFormattedMessage id={"create-account"} />
            </APButton>

            <APButton flexFill size={"sm"} variant={"solid"} colorScheme={"secondary"} textDecoration={"underline"}
                      onClick={onContinue}>
              <APFormattedMessage id={"continue-without-login"} />
            </APButton>
          </ModalBody>
        </ModalContent>
      </ModalOverlay>
    </Modal>)
}